import {
  TimelineProps as MantineTimelineProps,
  Timeline as MantineTimeline,
  TimelineItemProps as MantineTimelineItemProps,
  TimelineItem as MantineTimelineItem,
} from '@mantine/core';

export type TimelineProps = MantineTimelineProps;
export type TimelineItemProps = MantineTimelineItemProps;

export const Timeline = MantineTimeline;
Timeline.displayName = 'Timeline';

export const TimelineItem = MantineTimelineItem;
TimelineItem.displayName = 'TimelineItem';
